import React, { useRef, useState } from "react";
import JobDetailsApplyPopup from "../../job-details/components/JobDetailsApplyPopup";

import twitter from "../img/social/twitter.png";
import facebook from "../img/social/facebook.png";
import instagram from "../img/social/instagram.png";
import linkedin from "../img/social/linkedin.png";

export default function App(props) {
  return (
    <>
      <div>
        {/* <JobDetailsApplyPopup
          showApply={this.state.isapplymodalopen}
          jobdetails={jobdetails}
          handler={this.handler}
        /> */}
        <div class=" py-0">
          {/* <card class="bg-white flex justify-center items-center"> */}
            {/* <div>
              <div className="flex justify-evenly">
                <img src={twitter} />
                <img src={facebook} />
                <img src={instagram} />
                <img src={linkedin} />
              </div>
              <p className="fsize14 copywrite-color mt-4">
                ©2021 - ICICI Careers | All right reserved
              </p>
            </div> */}
            {/* <button
              className="cust-filled-btn-blue flex mr-4  sm-w155px  sm-fsize15"
              onClick={() => props.applyFooter()}
            > */}
              {/* {this.props.isAlreadyApplied ? "Applied" : "APPLY NOW"} */}
              {/* APPLY NOW
            </button>
          </card> */}
        </div>
      </div>
    </>
  );
}
